import "@/index.css";
import { Link, Route, Routes } from "react-router";
import { ScrollToTop } from "@/components/ScrollToTop";
import { DeleteAccountPage } from "@/pages/DeleteAccountPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { TermsPage } from "@/pages/TermsPage";
import antbot from "@/assets/images/antbot.jpg";
import connectExchange from "@/assets/images/connectExchange.jpg";
import dailyReport from "@/assets/images/dailyReport.jpg";
import exchangeDetail from "@/assets/images/exchangeDetail.jpg";
import exploreMarket from "@/assets/images/exploreMarket.jpg";
import exploreNews from "@/assets/images/exploreNews.jpg";
import map from "@/assets/images/map.jpg";
import mySettings from "@/assets/images/mySettings.jpg";
import portfolio from "@/assets/images/portfolio.jpg";
import rank from "@/assets/images/rank.jpg";
import settings from "@/assets/images/settings.jpg";
import sharedPortfolio from "@/assets/images/sharedPortfolio.jpg";

const playStoreUrl = "https://play.google.com/store/apps/details?id=com.gamgyule.ggpp";
const brand = "앤트";
const heroBadge = "거래소부터 AI 요약까지, 한눈에";
const heroTitle = ["내 코인 자산,", "어디서 어떻게", "움직이는지", "쉽게 봐요"];
const heroBody =
  "앤트는 여러 거래소에 흩어진 자산을 모아 보여줘요. 시장 분위기, 지역별 수익률, 내 포트폴리오 변화를 같은 화면에서 자연스럽게 이어서 볼 수 있어요.";
const downloadCta = "Google Play에서 다운로드";
const downloadCtaShort = "앱 다운로드";
const ctaPrimary = "기능 둘러보기";
const ctaSecondary = "AI 요약 보기";
const contactCta = "앱 다운로드";
const contactCtaMobile = "다운로드";
const backToTop = "상단으로 이동";

const proofCards = [
  {
    label: "거래소는 한 번에",
    copy: "여러 거래소에 나뉜 자산을 연결해서 한곳에서 볼 수 있어요.",
  },
  {
    label: "변화는 빠르게",
    copy: "평가 금액과 수익률이 어떻게 바뀌는지 바로 확인해요.",
  },
  {
    label: "판단은 가볍게",
    copy: "시장 분위기와 내 자산 변화를 요약해서 다음 선택을 도와줘요.",
  },
];

const featureCards = [
  {
    eyebrow: "거래소 모아보기",
    title: "흩어진 자산을 한 화면에 모아봐요",
    body: "거래소마다 따로 들어갈 필요 없이, 연결한 자산과 수익률 변화를 같은 기준으로 볼 수 있어요.",
    image: connectExchange,
    alt: "여러 거래소 연동 화면",
  },
  {
    eyebrow: "지역별 수익률",
    title: "다른 지역은 어떤 흐름인지 지도에서 봐요",
    body: "지역별 수익률을 지도 위에 보여줘서, 숫자만 볼 때 놓치기 쉬운 분위기까지 쉽게 읽을 수 있어요.",
    image: map,
    alt: "지역 기반 수익률 지도 화면",
  },
  {
    eyebrow: "시장과 내 자산",
    title: "시장 흐름과 내 포트폴리오를 같이 봐요",
    body: "거래소별 수익률, 평가 금액, 투자 성과를 시장 정보와 함께 보여줘서 지금 내 위치를 이해하기 쉬워요.",
    image: portfolio,
    alt: "포트폴리오 화면",
  },
];

const intelligenceShots = [
  {
    title: "AI 요약",
    copy: "궁금한 건 바로 묻고, 지금 챙겨볼 내용을 짧게 받아요.",
    image: antbot,
    alt: "AI 투자 질문 예시 화면",
  },
  {
    title: "데일리 리포트",
    copy: "오늘의 자산 변화와 주요 이슈를 부담 없이 훑어봐요.",
    image: dailyReport,
    alt: "데일리 리포트 화면",
  },
  {
    title: "시장 탐색",
    copy: "전체 시장 흐름을 보고, 관심 가는 테마를 빠르게 찾아요.",
    image: exploreMarket,
    alt: "시장 탐색 화면",
  },
  {
    title: "뉴스 탐색",
    copy: "시세에 영향을 줄 만한 뉴스와 이슈를 흐름대로 모아봐요.",
    image: exploreNews,
    alt: "뉴스 탐색 화면",
  },
];

const dashboardCards = [
  {
    title: "내 지역 등록",
    body: "내 지역을 등록하고, 주변 수익률 흐름과 시장 분위기를 함께 비교해요.",
    image: mySettings,
    alt: "내 지역 등록 화면",
  },
  {
    title: "거래소 상세",
    body: "거래소마다 자산이 얼마나 있고 어떻게 움직였는지 자세히 봐요.",
    image: exchangeDetail,
    alt: "거래소 상세 화면",
  },
  {
    title: "랭킹과 비교",
    body: "내 성과가 어느 정도인지 다른 참여자 흐름과 가볍게 비교해요.",
    image: rank,
    alt: "랭킹 화면",
  },
  {
    title: "공유 포트폴리오",
    body: "내 포트폴리오 성과를 필요한 사람에게 쉽게 공유해요.",
    image: sharedPortfolio,
    alt: "공유 포트폴리오 화면",
  },
  {
    title: "설정과 연결 관리",
    body: "거래소 연결 상태와 앱 설정을 한곳에서 간단히 관리해요.",
    image: settings,
    alt: "설정 화면",
  },
];

const overviewLeadTitle = ["숫자만 보지 말고,", "흐름까지 같이 봐요"];
const overviewLeadBody =
  "자산이 얼마인지 보는 것에서 끝나지 않게 만들었어요. 거래소별 변화, 지역별 수익률, 시장 이슈를 한 흐름으로 이어서 볼 수 있어요.";
const overviewCards = [
  {
    eyebrow: "흐름",
    title: "거래소별 변화를 비교해요",
    body: "어느 거래소에서 자산이 늘고 줄었는지 한눈에 보고, 수익률 변화도 함께 살펴봐요.",
  },
  {
    eyebrow: "신호",
    title: "지역별 분위기를 읽어요",
    body: "내 지역을 등록하면 지역별 수익률 흐름을 지도에서 보고, 시장 분위기를 더 쉽게 읽을 수 있어요.",
  },
  {
    eyebrow: "AI 요약",
    title: "뉴스와 내 자산을 같이 정리해요",
    body: "최근 뉴스, 시장 분위기, 거래소별 자산 변화를 묶어서 지금 먼저 볼 내용을 알려줘요.",
    wide: true,
  },
];
const intelligenceTitle = ["복잡한 데이터는 모으고,", "설명은 짧게"];
const intelligenceBody =
  "앤트는 시장 뉴스, 거래소별 자산 상태, 내 수익률을 함께 정리해 지금 봐야 할 내용을 먼저 보여줘요.";
const dashboardTitle = [
  "내 자산을 보는 방식이",
  "더 쉬워져요",
];
const footerTitle = [
  "시장 흐름부터 내 성과까지,",
  "앤트에서 이어서 봐요",
];
const footerBody =
  "여러 거래소에 흩어진 자산과 시장 흐름을 한곳에서 보고, 다음 선택을 더 쉽게 준비해요.";

function HomePage() {
  return (
    <main
      id="top"
      className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.72),_rgba(249,241,231,0.96)_42%,_#efe4d6_100%)] text-stone-950"
    >
      <section className="relative isolate">
        <div className="mx-auto flex min-h-screen w-full max-w-7xl flex-col px-5 pb-16 pt-6 sm:px-8 lg:px-10">
          <header className="mb-10 rounded-[1.75rem] border border-white/60 bg-white/55 px-4 py-3 shadow-[0_24px_80px_rgba(120,76,34,0.09)] backdrop-blur md:rounded-full md:px-6">
            <div className="flex items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-[0.68rem] font-semibold uppercase tracking-[0.34em] text-amber-700/70">
                Crypto Portfolio Companion
              </p>
              <p className="text-lg font-semibold tracking-[-0.03em]">{brand}</p>
            </div>
            <a href={playStoreUrl} target="_blank" rel="noreferrer" className="inline-flex shrink-0 rounded-full bg-stone-950 px-3 py-2 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 md:px-4">
              <span className="md:hidden">{contactCtaMobile}</span>
              <span className="hidden md:inline">{contactCta}</span>
            </a>
            </div>

            <nav className="mt-3 grid grid-cols-3 items-center gap-2 text-center text-sm text-stone-700 md:hidden">
              <a href="#overview" className="rounded-full bg-white/70 px-3 py-2 transition-colors hover:text-stone-950">소개</a>
              <a href="#features" className="rounded-full bg-white/70 px-3 py-2 transition-colors hover:text-stone-950">기능</a>
              <a href="#intelligence" className="rounded-full bg-white/70 px-3 py-2 transition-colors hover:text-stone-950">AI 요약</a>
            </nav>

            <nav className="hidden items-center gap-6 text-sm text-stone-700 md:flex">
              <a href="#overview" className="transition-colors hover:text-stone-950">소개</a>
              <a href="#features" className="transition-colors hover:text-stone-950">기능</a>
              <a href="#intelligence" className="transition-colors hover:text-stone-950">AI 요약</a>
            </nav>
          </header>

          <div className="grid flex-1 items-center gap-12 lg:grid-cols-[1.08fr_0.92fr]">
            <div className="max-w-3xl">
              <p className="mb-4 inline-flex rounded-full border border-amber-300/60 bg-white/65 px-4 py-2 text-sm font-medium text-amber-800 shadow-[0_20px_40px_rgba(120,76,34,0.08)] backdrop-blur">
                {heroBadge}
              </p>
              <h1 className="max-w-4xl text-5xl font-black  text-stone-950 sm:text-6xl lg:text-7xl">
                {heroTitle[0]}
                <br />
                {heroTitle[1]}
                <br />
                {heroTitle[2]}
                <br />
                {heroTitle[3]}
              </h1>
              <p className="mt-6 max-w-2xl text-base leading-8 text-stone-700 sm:text-lg">{heroBody}</p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a href={playStoreUrl} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center rounded-full bg-[#ef8f29] px-6 py-3.5 text-sm font-semibold text-white shadow-[0_20px_50px_rgba(239,143,41,0.34)] transition-transform duration-300 hover:-translate-y-0.5">
                  {downloadCta}
                </a>
                <a href="#features" className="inline-flex items-center justify-center rounded-full border border-stone-900/10 bg-white/70 px-6 py-3.5 text-sm font-semibold text-stone-900 backdrop-blur transition-colors hover:bg-white">
                  {ctaPrimary}
                </a>
                <a href="#intelligence" className="inline-flex items-center justify-center rounded-full border border-stone-900/10 bg-white/45 px-6 py-3.5 text-sm font-semibold text-stone-900 backdrop-blur transition-colors hover:bg-white sm:hidden">
                  {ctaSecondary}
                </a>
              </div>

              <div className="mt-10 grid gap-4 sm:grid-cols-3">
                {proofCards.map(card => (
                  <article key={card.label} className="rounded-[2rem] border border-white/70 bg-white/65 p-6 shadow-[0_30px_60px_rgba(126,92,55,0.08)] backdrop-blur">
                    <h2 className="text-base font-bold text-stone-950">{card.label}</h2>
                    <p className="mt-2 text-sm leading-6 text-stone-600">{card.copy}</p>
                  </article>
                ))}
              </div>
            </div>

            <div className="relative mx-auto w-full max-w-2xl">
              <div className="absolute left-[8%] top-[6%] h-36 w-36 rounded-full bg-orange-300/35 blur-3xl" />
              <div className="absolute bottom-[10%] right-[4%] h-44 w-44 rounded-full bg-emerald-300/30 blur-3xl" />
              <div className="hero-grid relative">
                <figure className="hero-card hero-card-main rotate-[-6deg]">
                  <img src={portfolio} alt="포트폴리오 메인 화면" className="h-full w-full object-cover" />
                </figure>
                <figure className="hero-card hero-card-top rotate-[8deg]">
                  <img src={antbot} alt="AI 어시스턴트 화면" className="h-full w-full object-cover" />
                </figure>
                <figure className="hero-card hero-card-bottom rotate-[4deg]">
                  <img src={map} alt="지역 기반 수익률 지도 화면" className="h-full w-full object-cover" />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="overview" className="mx-auto w-full max-w-7xl px-5 py-10 sm:px-8 lg:px-10">
        <div className="grid gap-5 lg:grid-cols-[0.95fr_1.05fr]">
          <article className="rounded-[2rem] bg-stone-950 p-8 text-white shadow-[0_34px_90px_rgba(31,19,10,0.18)]">
            <p className="text-sm uppercase tracking-[0.3em] text-amber-300/75">Overview</p>
            <h2 className="mt-4 text-3xl font-black tracking-[-0.05em] sm:text-4xl">
              {overviewLeadTitle[0]}
              <br />
              {overviewLeadTitle[1]}
            </h2>
            <p className="mt-5 max-w-xl text-sm leading-7 text-stone-300 sm:text-base">{overviewLeadBody}</p>
          </article>

          <div className="grid gap-5 sm:grid-cols-2">
            {overviewCards.map(card => (
              <article
                key={card.title}
                className={`rounded-[2rem] border border-stone-900/8 bg-white/70 p-6 shadow-[0_24px_60px_rgba(126,92,55,0.08)] backdrop-blur ${
                  card.wide ? "sm:col-span-2" : ""
                }`}
              >
                <p className="text-sm font-semibold uppercase tracking-[0.26em] text-amber-700/75">{card.eyebrow}</p>
                <h3 className="mt-3 text-2xl font-black tracking-[-0.05em]">{card.title}</h3>
                <p className="mt-3 text-sm leading-7 text-stone-600">{card.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="features" className="mx-auto flex w-full max-w-7xl flex-col gap-16 px-5 py-16 sm:px-8 lg:px-10">
        {featureCards.map((feature, index) => (
          <article
            key={feature.title}
            className={`grid items-center gap-8 rounded-[2.5rem] border border-white/70 bg-white/60 p-5 shadow-[0_30px_90px_rgba(126,92,55,0.09)] backdrop-blur md:p-8 lg:grid-cols-2 ${
              index % 2 === 1 ? "lg:[&>figure]:order-1 lg:[&>div]:order-2" : ""
            }`}
          >
            <div className="max-w-2xl">
              <p className="text-sm font-semibold uppercase tracking-[0.3em] text-amber-700/70">{feature.eyebrow}</p>
              <h2 className="mt-4 text-3xl font-black leading-tight tracking-[-0.05em] text-stone-950 sm:text-4xl">
                {feature.title}
              </h2>
              <p className="mt-5 text-sm leading-7 text-stone-600 sm:text-base">{feature.body}</p>
            </div>
            <figure className="overflow-hidden rounded-[2rem] border border-stone-900/8 bg-white shadow-[0_24px_60px_rgba(31,19,10,0.12)]">
              <img src={feature.image} alt={feature.alt} className="h-full w-full object-cover" />
            </figure>
          </article>
        ))}
      </section>

      <section id="intelligence" className="relative overflow-hidden bg-stone-950 py-20 text-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(239,143,41,0.22),_transparent_28%),radial-gradient(circle_at_bottom_right,_rgba(58,180,140,0.18),_transparent_24%)]" />
        <div className="relative mx-auto w-full max-w-7xl px-5 sm:px-8 lg:px-10">
          <div className="max-w-3xl">
            <p className="text-sm uppercase tracking-[0.32em] text-amber-300/70">AI Summary</p>
            <h2 className="mt-4 text-4xl font-black tracking-[-0.06em] sm:text-5xl">
              {intelligenceTitle[0]}
              <br />
              {intelligenceTitle[1]}
            </h2>
            <p className="mt-5 text-sm leading-7 text-stone-300 sm:text-base">{intelligenceBody}</p>
          </div>

          <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-4">
            {intelligenceShots.map(item => (
              <article key={item.title} className="group rounded-[2rem] border border-white/10 bg-white/6 p-4 shadow-[0_28px_70px_rgba(0,0,0,0.28)] backdrop-blur-sm transition-transform duration-300 hover:-translate-y-1">
                <div className="overflow-hidden rounded-[1.5rem]">
                  <img src={item.image} alt={item.alt} className="h-[320px] w-full object-contain transition-transform duration-500 group-hover:scale-[1.03]" />
                </div>
                <h3 className="mt-4 text-xl font-bold tracking-[-0.04em]">{item.title}</h3>
                <p className="mt-2 text-sm leading-6 text-stone-300">{item.copy}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto w-full max-w-7xl px-5 py-16 sm:px-8 lg:px-10">
        <div className="mb-8 max-w-3xl">
          <p className="text-sm uppercase tracking-[0.32em] text-amber-700/70">Dashboard</p>
          <h2 className="mt-3 text-3xl font-black tracking-[-0.05em] text-stone-950 sm:text-4xl">
            {dashboardTitle[0]}
            <br />
            {dashboardTitle[1]}
          </h2>
        </div>

        <div className="dashboard-grid">
          {dashboardCards.map(card => (
            <article key={card.title} className="overflow-hidden rounded-[2rem] border border-stone-900/8 bg-white shadow-[0_24px_60px_rgba(126,92,55,0.08)] backdrop-blur">
              <img src={card.image} alt={card.alt} className="h-[300px] w-full object-contain object-top" />
              <div className="p-6">
                <h3 className="text-2xl font-black tracking-[-0.05em] text-stone-950">{card.title}</h3>
                <p className="mt-3 text-sm leading-7 text-stone-600">{card.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="contact" className="px-5 pb-20 pt-4 sm:px-8 lg:px-10">
        <div className="mx-auto max-w-7xl rounded-[2.5rem] bg-[linear-gradient(135deg,#17120f_0%,#302015_100%)] px-6 py-10 text-white shadow-[0_40px_110px_rgba(31,19,10,0.28)] sm:px-10 sm:py-12">
          <p className="text-sm uppercase tracking-[0.3em] text-amber-300/70">Get Started</p>
          <div className="mt-4 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <h2 className="text-3xl font-black leading-tight tracking-[-0.05em] sm:text-5xl">
                {footerTitle[0]}
                <br />
                {footerTitle[1]}
              </h2>
              <p className="mt-5 text-sm leading-7 text-stone-300 sm:text-base">{footerBody}</p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
              <a href={playStoreUrl} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center rounded-full bg-[#ef8f29] px-6 py-3.5 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5">
                {downloadCtaShort}
              </a>
              <a href="#top" className="inline-flex items-center justify-center rounded-full border border-white/15 bg-white/10 px-6 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/15">
                {backToTop}
              </a>
            </div>
          </div>
          <nav className="mt-8 flex flex-wrap gap-4 border-t border-white/10 pt-5 text-sm font-semibold text-stone-300">
            <Link to="/privacy-policy" className="transition-colors hover:text-white">
              개인정보 처리 방침
            </Link>
            <Link to="/terms" className="transition-colors hover:text-white">
              이용 약관
            </Link>
          </nav>
        </div>
      </section>
    </main>
  );
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </>
  );
}

export default App;
